import React from 'react'
import PropTypes from 'prop-types'

// const regEx = `/\[icon\s?(?:name=")?([^\]]*)\"\]/g`

const Text = ({ apiElement }) => {
	const shortcodesApplied = apiElement.text.replace(
		/\[icon_([^\]]*)\]/g,
		(matchedString, name) => {
			// const iconName = name !== '' ?  name : 'homeopathy'

			return `<div class="icon shortcode icon_${name} active" ></div>`
		}
	)

	return (
		<div
			className={`text_block align_${apiElement.text_align}`} // eslint-disable-next-line
			dangerouslySetInnerHTML={{
				__html: shortcodesApplied || null
			}}
		/>
	)
}

Text.defaultProps = {
	apiElement: {}
}
Text.propTypes = {
	apiElement: PropTypes.object // eslint-disable-line
}

export default Text
